import { Link } from 'react-router-dom';
import { KWELLO_ICON, KwelloSvgIcon } from '../../components/icon/KwelloSvgIcon';
import { MODULE_ROUTES } from 'routes/routes.const';

const Footer = ({ fixed }: { fixed: boolean }) => {
  const mailto = 'mailto:support@accelerationpoint.com?subject=Kwello Support Request';
  const year = new Date().getFullYear();

  return (
    <div className={`footer ${fixed ? 'footer-fixed' : ''} small-soft-desktop-blue-900`}>
      <span className="copyright">
        Copyright &copy;
        {year}
        &nbsp; Acceleration Point. All rights reserved
      </span>
      <Link to={MODULE_ROUTES.privacyPolicy}>Privacy Policy</Link>
      <Link to={MODULE_ROUTES.terms}>Terms of Use</Link>
      <Link to={MODULE_ROUTES.cookies}>Cookies</Link>
      <a
        data-test="link-contact-us"
        href="#"
        onClick={(e) => {
          window.location.href = mailto;
          e.preventDefault();
        }}
      >
        Contact Us
      </a>
      <span className="kwello-icon">
        <KwelloSvgIcon icon={KWELLO_ICON.KWELLO_LOGO} />
      </span>
    </div>
  );
};

export default Footer;
